import React from "react";
// COMPONENTS
import FormInputText from "../../../../components/form/FormInputText";

/**
 * Connection-scoped OPC UA settings on the adapter CDO. The endpoint URL
 * itself moved to the Channel (see `StepChannels.tsx`'s
 * `isValidOpcUaEndpointUrl`/`opcUaEndpointUrl` field) since the connection
 * target belongs to the channel, not the per-adapter mapping config
 * (flatbuffer_schemas 0697cf91).
 */
export default function ConnectionEditor({
  applicationName,
  onChangeApplicationName,
}: {
  applicationName: string;
  onChangeApplicationName: (value: string) => void;
}) {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12 col-md-6 mt-3">
          <FormInputText
            inputValue={applicationName}
            inputLabelName="Application Name"
            inputOnChange={(value) => onChangeApplicationName(value)}
            inputVariableName="applicationName"
            isRequired={false}
            disabledInput={false}
          />
        </div>
      </div>
    </div>
  );
}
